class FileUploadFocus {
	constructor(fileInputContainer) {
		if (fileInputContainer.length === 0) return;
		[].slice.call(fileInputContainer).forEach((el) => {
			const input = el.querySelector('.form-components__upload-input');
			const label = el.querySelector('label');

			input.addEventListener('focus', ()=> {
				label.classList.add('jsFocus')
			});

			input.addEventListener('blur', ()=> {
				label.classList.remove('jsFocus')
			});
		});
	}
}

export default FileUploadFocus;
